module.exports = __webpack_public_path__ + "static/media/aboutImg.c073ba52.png";